"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecognitionTimes = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var RecognitionTimes = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RecognitionTimes, _super);
    function RecognitionTimes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '人体识别次数接口';
        _this.code = '101132';
        _this.desc = '人体识别次数接口';
        _this.requestParams = new cashLoanAuth_1.RecognitionTimesRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RecognitionTimes;
}(service_1.BaseService));
exports.RecognitionTimes = RecognitionTimes;
//# sourceMappingURL=recognitionTimes.js.map